import { useAppContext } from "../../shared/functions/Context";
import EmptyError from "../admin-settings/EmptyError";
import showModalFromId from "../../shared/functions/ModalShow";
import MODAL_NAMES from "../dialogs/ModalName";
import { IScorecardMetadata } from "../../shared/models/ScorecardMetadata";
import { observer } from "mobx-react-lite";
import ErrorBoundary from "../../shared/components/error-boundary/ErrorBoundary";
import { exportDepartmentPerformanceOverview } from "../shared/functions/Excel";

interface IReviewPeopleProps {
  scorecards: IScorecardMetadata[];
}
const ReviewDepartment = observer((props: IReviewPeopleProps) => {
  const { scorecards } = props;
  const { store } = useAppContext();

  const statusClassName = (status: string) => `status status__${status}`;

  const onExportExcel = async () => {
    await exportDepartmentPerformanceOverview(scorecards);
  };

  const onView = (item: IScorecardMetadata) => {
    showModalFromId(MODAL_NAMES.PERFORMANCE_REVIEW.DEPARTMET_REVIEW_MODAL);
    store.departmentScorecardMetadata.select(item);
  };

  return (
    <ErrorBoundary>
      <div className="review-staff">
        <div className="review-staff--toolbar uk-margin">
          <h6 className="title">Scorecard Reviews</h6>
          <span>
            <button
              className="btn btn-primary uk-margin-left"
              onClick={onExportExcel}>
              Export Report
            </button>
          </span>
        </div>
        <table className="people-table uk-table uk-table-small uk-table-middle uk-table-hover uk-table-divider">
          <thead className="header">
            <tr>
              <th>#</th>
              <th>Department Name</th>
              <th>Scorecard</th>
              <th>Q1 Status</th>
              <th>Midterm</th>
              <th>Q3 Status</th>
              <th>Assessment</th>
            </tr>
          </thead>
          <tbody>
            {scorecards.map((scorecard, index) => (
              <tr
                className="row"
                key={scorecard.uid}
                onClick={() => onView(scorecard)}
              >
                <td>{index + 1}</td>
                <td>{scorecard.departmentName}</td>
                <td>
                  <div
                    className={statusClassName(scorecard.agreementDraft.status)}
                  >
                    {scorecard.agreementDraft.status}
                  </div>
                </td>
                <td>
                  <div
                    className={statusClassName(scorecard.quarter1Review.status)}
                  >
                    {scorecard.quarter1Review.status}
                  </div>
                </td>
                <td>
                  <div
                    className={statusClassName(scorecard.quarter2Review.status)}
                  >
                    {scorecard.quarter2Review.status}
                  </div>
                </td>
                <td>
                  <div
                    className={statusClassName(scorecard.quarter3Review.status)}
                  >
                    {scorecard.quarter3Review.status}
                  </div>
                </td>
                <td>
                  <div
                    className={statusClassName(scorecard.quarter4Review.status)}
                  >
                    {scorecard.quarter4Review.status}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!store.department.all.length && <EmptyError errorMessage="No departments found" />}
      </div>
    </ErrorBoundary>
  );
});

export default ReviewDepartment;
